// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__K6rsU","header":"PatientQuestionnaire_header__2NhB3","info":"PatientQuestionnaire_info__25EWz"};